'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import ContactUsDialog from '@/components/ui/ContactUsDialog';

const FloatingContactButton = () => {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  return (
    <>
      {/* Floating Contact Button */}
      <button data-component-id="src/components/ui/FloatingContactButton.tsx:13:6" data-component-path="src/components/ui/FloatingContactButton.tsx" data-component-line="13" data-component-end-line="23" data-component-file="FloatingContactButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20right-6%20bottom-6%20z-40%20bg-primary%20text-primary-foreground%20p-4%20rounded-full%20shadow-warm-lg%20hover%3Abg-primary%2F90%20transition-all%20duration-300%20ease-in-out%20hover%3Ascale-110%20focus%3Aoutline-none%20focus%3Aring-4%20focus%3Aring-ring%20focus%3Aring-offset-2%20group%22%7D"
        onClick={() => setIsContactDialogOpen(true)}
        className="fixed right-6 bottom-6 z-40 bg-primary text-primary-foreground p-4 rounded-full shadow-warm-lg hover:bg-primary/90 transition-all duration-300 ease-in-out hover:scale-110 focus:outline-none focus:ring-4 focus:ring-ring focus:ring-offset-2 group"
        aria-label="Contact us"
      >
        <Icon data-component-id="src/components/ui/FloatingContactButton.tsx:18:8" data-component-path="src/components/ui/FloatingContactButton.tsx" data-component-line="18" data-component-end-line="22" data-component-file="FloatingContactButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChatBubbleLeftRightIcon%22%2C%22className%22%3A%22group-hover%3Aanimate-pulse%22%7D"
          name="ChatBubbleLeftRightIcon"
          size={24}
          className="group-hover:animate-pulse"
        />
      </button>

      {/* Contact Us Dialog */}
      <ContactUsDialog data-component-id="src/components/ui/FloatingContactButton.tsx:26:6" data-component-path="src/components/ui/FloatingContactButton.tsx" data-component-line="26" data-component-end-line="29" data-component-file="FloatingContactButton.tsx" data-component-name="ContactUsDialog" data-component-content="%7B%22elementName%22%3A%22ContactUsDialog%22%7D"
        isOpen={isContactDialogOpen}
        onClose={() => setIsContactDialogOpen(false)}
      />
    </>
  );
};

export default FloatingContactButton;
